import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const DisciplineDoctorSelection = ({
  selectedDiscipline,
  handleDisciplineChange,
  patientName,
  mockDisciplines,
  selectedClinic,
  loadingDoctors,
  availableDoctors,
  selectedDoctor,
  handleDoctorChange,
}) => {
  const { t } = useTranslation(); // ✅ Hook for translations

  return (
    <>
      {/* Discipline Selection */}
      <div className="sched-discipline-select">
        <label>{t("patient_view_discipline.select_discipline")}:</label>
        <select
          className="sched-select"
          value={selectedDiscipline || ""}
          onChange={handleDisciplineChange}
          disabled={!patientName}
        >
          <option value="">{t("patient_view_discipline.select")}</option>
          {mockDisciplines.map((discipline, index) => (
            <option key={index} value={discipline}>
              {discipline}
            </option>
          ))}
        </select>
      </div>

      {/* Practitioner Selection */}
      <div className="sched-doctor-select">
        {selectedClinic && selectedDiscipline ? (
          <>
            <label>{t("patient_view_discipline.select_practitioner")}</label>
            {loadingDoctors ? (
              <p>{t("patient_view_discipline.loading_practitioners")}</p>
            ) : availableDoctors.length === 0 ? (
              <div className="no-doctors-banner">
                <p>{t("patient_view_discipline.no_practitioners_available")}</p>
              </div>
            ) : (
              <select
                className="sched-select"
                value={selectedDoctor || ""} // Display selected doctor
                onChange={handleDoctorChange}
              >
                <option value="">{t("patient_view_discipline.select")}</option>
                {availableDoctors.map((doctor) => (
                  <option key={doctor.id} value={`${doctor.firstName} ${doctor.lastName}`}>
                    {doctor.firstName} {doctor.lastName}
                  </option>
                ))}
              </select>
            )}
          </>
        ) : (
          <p>{t("patient_view_discipline.select_clinic_and_discipline")}</p>
        )}
      </div>
    </>
  );
};

DisciplineDoctorSelection.propTypes = {
  selectedDiscipline: PropTypes.string,
  handleDisciplineChange: PropTypes.func.isRequired,
  patientName: PropTypes.string.isRequired,
  mockDisciplines: PropTypes.array.isRequired,
  selectedClinic: PropTypes.object,
  loadingDoctors: PropTypes.bool.isRequired,
  availableDoctors: PropTypes.array.isRequired,
  selectedDoctor: PropTypes.string,
  handleDoctorChange: PropTypes.func.isRequired,
};

export default DisciplineDoctorSelection;
